import { intl } from '@/intl'

export const formatMinutes = (value: number) =>
  intl.translate({ id: 'global.plural.short.minutes', values: { value } })
